module.exports = __webpack_public_path__ + "static/media/fly0036.557c8248.webp";